// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".4cd0e4e46327a65919a559e0c0363a1a6cb796c0.chunk.bundle.js";
};